import { BookingFinalConfirmationTemplate } from "./booking-final-confirmation-template";

export class BookingFinalConfirmationTemplateWithDetail extends BookingFinalConfirmationTemplate {

    public body: string;

    constructor(
        id: number,
        name: string,
        body: string
    ){
        super(id, name);
        this.body = body;
    }
}
